//Menu 
$(document).ready(function(){ 
  // $('.slideshow-section .itg--height-auto').css('height', '100%');
  // $('.slideshow-section .itg--height-auto').css('min-height', '100vh');
  // $('.slideshow-section .itg--height-auto').css('--desktop-height', 'auto');
 /* $("li[data-submenu-parent]").hover(
    function () {
       $(this).find('.navigation__submenu[data-depth="1"]').fadeIn(500);
    },
    function () {
       $(this).find('.navigation__submenu[data-depth="1"]').fadeOut(500);
    }
  );

   $("li.navigation__submenu-item").hover(
    function () {
       $(this).find('.navigation__submenu[data-depth="2"]').fadeIn(500);
    },
    function () {
       $(this).find('.navigation__submenu[data-depth="2"]').fadeOut(500);
    }
  );*/


  $(window).on('scroll', function() {
    var height = $(window).scrollTop();
    var slideshowHeight = $('.slideshow-section .slideshow').height();
    if(height >= slideshowHeight) {
        $('header.header').removeClass('itg--header-active');
    } else {
        $('header.header').addClass('itg--header-active');
    }
  });


  $(document).on('click', '.faq-accordion .accordion1', function(){
    $(this).parents('.faq-accordion').toggleClass('active');
    $(this).parents('.faq-accordion').find('.acc-answer').slideToggle();
  });

  $(document).on('click', '.collection-sidebar h4', function(){
    if (window.matchMedia('(max-width: 799px)').matches){
    $(this).parents('.collection-sidebar').find('.toggle_list').slideToggle();
    $(this).parents('.collection-sidebar').toggleClass('active');
    }
  });

  $('.collection-sidebar .toggle_list li').find('ul.active').show();
  $('.collection-sidebar .toggle_list li').find('ul.active').siblings('.menu-toggle').addClass('active');
  $(document).on('click', '.collection-sidebar .toggle_list li .menu-toggle', function(){
    $(this).parents('li').find('ul').slideToggle();
    $(this).toggleClass('active');
  });


  
    $(document).on('click','#sliding_agree, [for="sliding_agree"]',function(e) {
      e.preventDefault();
      $('body,html').css('overflow', 'inherit');
      $('body,html').css('padding-right', '0');
      setTimeout (function() {
          if ($('#sliding_agree').is(':checked')) {
              $("#sliding_agree"). prop("checked", false); 
              $(".quick-cart.visible .quick-cart__container .btn.btn--secondary").addClass("BtnAgreeCheck"); 
          } else {
              $("#sliding_agree"). prop("checked", true); 
              $(".quick-cart.visible .quick-cart__container .btn.btn--secondary").removeClass("BtnAgreeCheck"); 
          }
         $('body,html').css('overflow', 'inherit');
        $('body,html').css('padding-right', '0');
        }, 150);
    });

    $(document).on('click','.BtnAgreeCheck',function(e) {
        e.preventDefault();
        $(".quick-cart.visible .quick-cart__container .checkoutWarning").fadeIn();
        $('body').css('overflow', 'inherit');
      $('body,html').css('padding-right', '0');
    });

    $(document).on('click','.quick-cart.visible .quick-cart__container .btn.btn--secondary:not(".BtnAgreeCheck")',function(e) {
        e.preventDefault();
        window.location = $(this).attr('href');
    });


  $(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {
        $('#return-to-top').fadeIn(200);
    } else {
        $('#return-to-top').fadeOut(200);
    }
});
$('#return-to-top').click(function() {
    $('body,html').animate({
        scrollTop : 0 
    }, 500);
});

function onloadAnnouncement(){
  var initial_msg = $('body').attr('initial_msg');
  var prefix = $('body').attr('prefix')+' ';
  var suffix = ' '+$('body').attr('suffix');
  var success = $('body').attr('success');
  var cartValue = parseFloat($('html').attr('carttotal'));
  var targetValue = parseFloat($('html').attr('targetValue'));
  var symbol = $('html').attr('currencySymbol');
  var price = $('.req_for_fs').attr('dataPrice');
  if (cartValue < targetValue && cartValue != 0){
    var olderText =  $('.ann_content').attr('data-text'); 
    $('span.ann_content').text(prefix+symbol+price+suffix);
  } else if (cartValue == 0) {
    var olderText =  $('.ann_content').attr('data-text'); 
    $('progress_title').text(prefix+symbol+price+suffix);
    $('.ann_content').text(initial_msg);
  } else {
    $('span.ann_content').text(success);
  }
  
}

function freeShippingStatus(){
  var initial_msg = $('body').attr('initial_msg');
  var prefix = $('body').attr('prefix')+' ';
  var suffix = ' '+$('body').attr('suffix');
  var success = $('body').attr('success');
  var cartValue =  $('.quick-cart__subtotal').html().substring(1);
  var cartValue =  parseFloat(cartValue.replace(",",""));
  var targetValue = parseFloat($('html').attr('targetValue'));
  var symbol = $('html').attr('currencySymbol');
  if (cartValue < targetValue && cartValue != 0){
    var percent = (cartValue/targetValue)*100 +'%';
    var requireValue = targetValue-cartValue;
    $('.progress_title,span.ann_content').text(prefix+symbol+requireValue+suffix);
    var olderText =  $('.ann_content').attr('data-text'); 
    //$('span.ann_content').text(olderText+prefix+symbol+requireValue+suffix);
    $('.current_value').css('width',percent);
  } else if (cartValue == 0) {
    var percent = (cartValue/targetValue)*100 +'%';
    var requireValue = targetValue-cartValue;
    $('.progress_title').text(prefix+symbol+requireValue+suffix);
    $('.ann_content').text(initial_msg);
    $('.current_value').css('width',percent);
  } else {
    $('.progress_title,span.ann_content').text(success);
    $('.current_value').css('width','100%');
  }
}  

onloadAnnouncement();
  /*
$(window).on('load', function() {
    freeShippingStatus();
    
});
*/
  
$(document).on('click','.quick-cart__item .quick-cart__control, a.icon-cart.header__icon-touch, a.quick-cart__item-remove',function(){
    setTimeout (function() {
        freeShippingStatus();
    }, 1000);  
});  

$(document).on('DOMSubtreeModified', ".quick-cart__items, .quick-cart__footer", function(event) {
    event.preventDefault();
    setTimeout (function() {
        freeShippingStatus();
    }, 1000);  
});

$(document).on('click','.quick-cart__overlay',function() {
  //$('.quick-cart').removeClass('visible active');
});   
  
    // class="quick-search visible active"
  
    function SwymGrLoopCheckUpdate () {
        if ($('.quick-search').hasClass('visible') && $('.quick-search').hasClass('active')) { } else {
         // 2024
           // $('.quick-search').addClass('visible active');
        }
    }
    
    var interval = self.setInterval(function(){SwymGrLoopCheckUpdate()},50);                
  
$(window).on('load',function(e) {});
  
  // e.preventDefault();
  // .stamped-summary-photos-container .stamped-photos-carousel .photo.stamped-photo a
  $('.stamped-summary-photos-container .stamped-photos-carousel .photo.stamped-photo a').each(function() {
          $(this).attr('href','#');
        $(this).removeAttr('target');
      });
    setTimeout (function() {
      $('.stamped-summary-photos-container .stamped-photos-carousel .photo.stamped-photo a').each(function() {
          $(this).attr('href','#');
        $(this).removeAttr('target');
      });
    },1000);
    setTimeout (function() {
      $('.stamped-summary-photos-container .stamped-photos-carousel .photo.stamped-photo a').each(function() {
        $(this).removeAttr('target');
        $(this).attr('href','#');
      });
    },3000);
    setTimeout (function() {
      $('.stamped-summary-photos-container .stamped-photos-carousel .photo.stamped-photo a').each(function() {
        $(this).removeAttr('target');
        $(this).attr('href','#');
      });
    },6000);
    setTimeout (function() {
      $('.stamped-summary-photos-container .stamped-photos-carousel .photo.stamped-photo a').each(function() {
       // $(this).attr('href','javascript: void(0)');
        $(this).removeAttr('target');
        $(this).attr('href','#');
      });
    },12000);
  

  
    $(document).on('click','.stamped-summary-photos-container .stamped-photos-carousel .photo.stamped-photo a',function(event) {
        event.preventDefault();
      //  event.stopPropagation();
    });

  // $(".header a.icon-cart.header__icon-touch").mouseenter(function() {
  //     $('.quick-cart[data-quick-cart]').addClass('active');
  //     setTimeout(function() {
  //       $('.quick-cart[data-quick-cart]').addClass('visible');
  //     }, 250);
  // });
  
  // $(".quick-cart__overlay").mouseenter(function() {
  //     $('.quick-cart[data-quick-cart]').removeClass('visible');
  //     setTimeout(function() {
  //       $('.quick-cart[data-quick-cart]').removeClass('active');
  //     }, 250);
  // });

  // $(document).mouseup(function(e) {
  //     var container = $(".quick-cart__overlay");
  //     if (container.is(e.target) ) { 
  //         $('.quick-cart[data-quick-cart]').removeClass('visible active');
  //     }
  // });
  
  /*
  $(document).mouseup(function(e) {
      // var container = $(".quick-cart__container");
      var container = $(".quick-cart__overlay");
  
      // if the target of the click isn't the container nor a descendant of the container
      if (container.is(e.target) ) {
        $('.quick-cart[data-quick-cart]').removeClass('visible active');
      }
  });
  */
  // $(".header a.icon-cart.header__icon-touch").mouseleave(function() {
  //     $('.quick-cart[data-quick-cart]').removeClass('active visible');
  // });

  // $('.drawer-menu__item .drawer-menu__link').unbind('click');

  $(document).on('click', '.drawer-menu__item a.drawer-menu__link', function(){
    var subMenu__href = $(this).attr('href');
    console.log(subMenu__href);
    window.location.href = subMenu__href;
    $('body').css({'opacity': '0', 'transition': '.3s'});
  });

  $(document).on('click', '.drawer-menu__item .drawer-menu__link .icon', function(e){
    e.stopPropagation();
  });

  $('.itg--meta-description .description').find('iframe').wrap('<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: 56.25% 0 0 0; "></div>');
  
});


// Quantity Left in Product page 
$(document).ready(function(){
  $(document).on('change','.product-form__controls-group .pf-element select ',function(){
    var Quantity = $(this).find('option:selected').attr('data-value');
    console.log(Quantity);
    if(Quantity <= 5 ){
      $(document).find('.items_left').text(Quantity + ' items left');
    }else{
      $(document).find('.items_left').text('');
    }
  });
});